import React, { useState, useEffect } from 'react'
import { Card, Button, Row, Form, message } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { resetSetting } from '../models'
import { Icon, C } from 'xadmin-ui'
import app, { api } from 'xadmin'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting, loading } = props;
  const { _t } = app.context;
  return (
    <Form className="form-horizontal" onFinish={handleSubmit} layout="vertical" autoComplete="on">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="submit" htmlType="submit" className="loginBtn ant-btn-primary" loading={loading} disabled={invalid}>{_t('提交')}</Button>
        </Row>
      </Card>
    </Form>
  );
}

const ResetPwd = () => {
  const [flag, setFlag] = useState(true)
  const [token, setToken] = useState()
  const [loading, setLoading] = React.useState(false)

  useEffect(() => {
    setToken(getCookie('token'))
    document.onkeydown = function (e) {
      switch (e.keyCode) {
        case 13:
          let radioList = document.getElementsByClassName('ant-radio-input')
          if (radioList?.length) {
            for (let i = 0; i < radioList.length; i++) {
              if (radioList[i].checked) {
                let value = { scene: radioList[i]?.value }
                onSubmit(value)
              }
            }
          }
          break;
      }
    }

  }, [])

  const getCookie = (cname) => {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return '';
  }

  const onSubmit = (value) => {
    setLoading(true)
    api({ name: 'core/setting' })
      .fetch('', {
        method: 'PATCH',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ scene: value.scene, indType: value.indType, onlineCheck: true })
      })
      .then(({ json }) => {
        setLoading(false)
        app.go('/systemSettingThird')
      })
      .catch(err => {
        message.error(err.message,err?.detail)
      })
  }

  const getSelectVer = (flag) => {
    // console.log(flag)
    setFlag(flag)
  }

  return (
    <div className="setGuideCard">
      <div className="guideContent">
        <div className="loginGuide" >
          <div className="loginBox loginProcess">
            <div className="cfix">
              <div className="rate-one">1</div>
              <span className="rate-span"></span>
              <div className="rate-one">2</div>
              {/* <span className="rate-span"></span>
              <div className="rate-one rate-none">3</div> */}
            </div>
            <p className="guideUse">系统配置</p>
          </div>
          <SchemaForm
            formKey={'resetSetting'}
            schema={resetSetting}
            component={props => <DefaultLayout {...props} loading={loading} />}
            group={C('Form.SimpleGroup')}
            onSubmit={(value) => onSubmit(value)}
          />
          <div className="loginBox">
            <p className="goReg goLogin" onClick={() => app.go('/systemSettingThird')}>跳过当前步骤</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPwd
